export const FETCH_FAVOURITE = 'FETCH_FAVOURITE'
export const RESET_FAVOURITE = 'RESET_FAVOURITE'
